import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { ArrowLeft } from "./ui";

export function Screen({
  title,
  subtitle,
  children,
  eyebrow = "Step Challenge",
  backTo,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  eyebrow?: string;
  backTo?: string;
}) {
  return (
    <div className="min-h-screen bg-background relative">
      <div
        className="fixed -top-25 -right-15 w-60 h-60 rounded-full bg-[rgba(32,191,107,0.08)]"
        aria-hidden="true"
      />
      <div
        className="fixed top-45 -left-12 w-40 h-40 rounded-full bg-[rgba(156,77,255,0.07)]"
        aria-hidden="true"
      />
      <div
        className="fixed bottom-25 -right-8 w-25 h-25 rounded-full bg-[rgba(56,182,255,0.07)]"
        aria-hidden="true"
      />
      <div className="px-4 pt-5 pb-9 flex flex-col gap-[1.125rem] min-h-screen max-w-3xl mx-auto w-full">
        <div className="flex flex-col gap-1.5 pt-1">
          <div className="flex flex-row items-center gap-1.5 mb-0.5">
            {backTo ? (
              <Link
                to={backTo}
                className="w-7 h-7 rounded-full border border-text flex items-center justify-center bg-white no-underline hover:bg-card-strong transition-colors mr-1"
              >
                <ArrowLeft />
              </Link>
            ) : null}
            <div className="w-1.5 h-1.5 rounded-full bg-aqua" />
            <span className="text-text-muted text-[0.625rem] font-bold tracking-[0.075em] uppercase">
              {eyebrow}
            </span>
          </div>
          <h1 className="text-text text-2xl font-extrabold leading-[1.875rem] max-w-[35rem] tracking-tight">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-text-muted text-sm leading-5 max-w-[40rem] mt-1">{subtitle}</p>
          ) : null}
        </div>
        {children}
      </div>
    </div>
  );
}
